module.exports = (__webpack_require__(14))(42);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/shallowequal/index.js from dll-reference vendor_library
// module id = 433
// module chunks = 0